import { render, staticRenderFns } from "./hist_vouchers.vue?vue&type=template&id=3dc4e093"
import script from "./hist_vouchers.vue?vue&type=script&lang=js"
export * from "./hist_vouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports